// src/components/profiles/ProfileList.jsx
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import ProfileCard from './ProfileCard';
import ProfileListSkeleton from './ProfileListSkeleton';

const ProfileList = ({ profiles = [], isLoading = false }) => {
  if (isLoading) {
    return <ProfileListSkeleton />;
  }

  if (!profiles.length) {
    return (
      <Box sx={{ 
        textAlign: 'center', 
        py: 10,
        backgroundColor: 'grey.50',
        borderRadius: 3,
        mt: 3
      }}>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          🕵️‍♀️ No profiles found
        </Typography>
        <Typography variant="text1" color="text.secondary">
          Try adjusting your filters or search criteria
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {profiles.map((profile) => (
        <Grid item xs={12} sm={6} md={4} key={profile.id || profile.profile_id}>
          <ProfileCard profile={profile} />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProfileList;